/**
 * documentLifecycleApi — CR-2026-DC-STATUS-MACHINE (D-032 §6).
 */

import ApiCall from './apicall';

export const LIFECYCLE_STATUSES = [
  'RECEIVED', 'IN_REVIEW', 'CHECKED', 'SUBMITTED_FOR_APPROVAL',
  'APPROVED', 'APPROVED_AS_NOTED',
  'CURRENT_FOR_FABRICATION', 'CURRENT_FOR_ERECTION', 'CURRENT_WITH_CORRECTIONS',
  'RETURNED_FOR_REVISION', 'REJECTED_HOLD',
  'SUPERSEDED', 'OBSOLETE', 'ARCHIVED_RECORD',
];

export const PRODUCTION_VISIBLE = [
  'CURRENT_FOR_FABRICATION', 'CURRENT_FOR_ERECTION', 'CURRENT_WITH_CORRECTIONS',
];

// Friendly status labels
export const LIFECYCLE_LABELS = {
  RECEIVED: 'Received',
  IN_REVIEW: 'In Review',
  CHECKED: 'Checked',
  SUBMITTED_FOR_APPROVAL: 'Submitted for Approval',
  APPROVED: 'Approved',
  APPROVED_AS_NOTED: 'Approved as Noted',
  CURRENT_FOR_FABRICATION: 'Current for Fabrication',
  CURRENT_FOR_ERECTION: 'Current for Erection',
  CURRENT_WITH_CORRECTIONS: 'Current with Corrections',
  RETURNED_FOR_REVISION: 'Returned for Revision',
  REJECTED_HOLD: 'Rejected / Hold',
  SUPERSEDED: 'Superseded',
  OBSOLETE: 'Obsolete',
  ARCHIVED_RECORD: 'Archived Record',
};

export async function getLifecycle(documentId) {
  const { data } = await ApiCall.get(`/documents/${documentId}/lifecycle`);
  return data;
}

export async function transitionLifecycle(documentId, target_status, reason = null) {
  const { data } = await ApiCall.post(`/documents/${documentId}/lifecycle/transition`, {
    target_status, reason,
  });
  return data;
}

// CR-2026-SFM-EOR-STAMP — record the EOR §1.7.0 approval stamp on a structural drawing.
export async function recordEorApproval(documentId, { decision, eor_name, eor_license, stamp_date = null, note = null }) {
  const { data } = await ApiCall.post(`/documents/${documentId}/record-eor-approval`, {
    decision, eor_name, eor_license, stamp_date, note,
  });
  return data;
}
